<template>
  <section :class="sectionClass" class="block">
    <div class="container">
      <PageHierarchySection
        v-editable="blok"
        :subheading="subheading"
        :title="title"
      >
        <div class="row flex-wrap">
          <CustomList :blok="blocks" :card-type="cardType" />
        </div>
      </PageHierarchySection>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlockCustomSectionStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: BlockCustomSectionStoryblok
}>()
const { sectionClass } = useStoryContent(toRefs(props))
const title = computed(() => props.blok.title)
const subheading = computed(() => props.blok.subheading)
const blocks = computed(() => props.blok.blocks)
const cardType = computed(() => props.blok.style)
</script>

<style lang="less" scoped>
section.block:first-child {
  :deep(section.page-hierarchy-section header) {
    margin-top: (@gutter-xxl + @gutter-xl) * 2;
  }
}
</style>
